      $(function(){ 
         $(document).on('click','.u_size_chart_trig_btn',function (e) {
      e.preventDefault();
    $(".u_size_chart_drawer_block").addClass("u_size_chart_drawer_active");
    $("html").addClass("u_cart_overflow");
  });
    $(document).on('click','.u_size_chart_overlay,.drawer__close-button',function () {
    $(".u_size_chart_drawer_block").removeClass("u_size_chart_drawer_active");
    $("html").removeClass("u_cart_overflow");
  });
    $('.u_pro_ptabs .u_tab_link').removeClass('u_tc_active');
   $('.u_pro_ptabs .u_tab_link:first-child').addClass('u_tc_active');
  $('.u_tab_content_wrapper .u_pro_tab_block').hide();
  $('.u_tab_content_wrapper .u_pro_tab_block:first').show();
 
$('.u_pro_ptabs .u_tab_link').click(function(){
   $('.u_pro_ptabs .u_tab_link').removeClass('u_tc_active');
  $('.u_pro_tab_block').hide();
  $(this).addClass('u_tc_active');
  var activetab =$(this).attr('data-id');
  console.log(activetab);
  $(activetab).show();
   $('.u_pro_slider_tab_wrapper').slick('setPosition');
  return false
});
})